// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2RiEP","subheader":"ReorderModal_subheader__G2uaK","listWrap":"ReorderModal_listWrap__3vmVJ"};